<template>
    <div>
        <le-pagview ref="bindlist" @setData="setTableData" :pageParam="pageParam" v-if="pageParam">
            <el-table :data="tabledata" @filter-change='filterFun'>
                <el-table-column 
                    :label="pageParam.params.opType | initTablelabel(opTypeDic,'操作类型')"
                    prop="typeText" 
                    column-key="opType"
                    :filter-multiple='false'
                    :filters="opTypeDic">
                    <template slot-scope="scope">
                        <el-tag size="small" :type='scope.row.type == 1 ? "danger":"primary"'>{{ scope.row.type | initDic(opTypeDic,'操作类型') }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="所属站点" v-if="deviceCode" prop="stationName"></el-table-column>
                <el-table-column label="设备号" v-if="stationId" prop="deviceCode"></el-table-column>
                <el-table-column label="绑定/解绑途径" v-if="deviceCode" prop="appIdText"></el-table-column>
                <el-table-column label="操作人" prop="operatorUserName">
                    <template slot-scope="{ row }">
                        <span>{{ row.operateUserName }} {{ row.operateUserPhone }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作时间" prop="createTimeText"></el-table-column>
            </el-table>
        </le-pagview>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                pageParam: null,
                tabledata: [],
                opTypeDic: [],//操作类型
            }
        },
        props:['deviceCode', 'stationId'],
        watch: {
            deviceCode: {
                immediate: true,
                handler (val) {
                    if(!val) return
                    this.pageParam = {
                        url: this.$Config.apiUrl.getDeviceOptionTimeline,
                        method: "post",
                        params: {
                            deviceCode: val,// 设备码
                            type: '',//操作类型
                        },
                        freshCtrl: 1,
                    }
                }
            },
            stationId: {
                immediate: true,
                handler (val) {
                    if(!val) return
                    this.pageParam = {
                        url: this.$Config.apiUrl.getStationDeviceOperationHistory,
                        method: "post",
                        params: {
                            stationId: val,// 设备码
                            type: '',//操作类型
                        },
                        freshCtrl: 1,
                    }
                }
            } 
        },
        created () {
            this.$getDic('deviceBindType').then(res=>{ this.opTypeDic = res; })
        },
        methods:{
            setTableData (datas) {
                this.tabledata = datas
            },
            filterFun (value) {
                for(var key in value){
                    if(key=='opType'){
                        if(value[key].length==0){
                            this.pageParam.params.type = ''
                        }else{
                            this.pageParam.params.type = value[key][0]
                        }
                    }
                }
                this.$refs['bindlist'].pageNum = 1;
                this.pageParam.freshCtrl++;
            }
        }
    }
</script>